import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Game from "./pages/Game";
import SignIn from "./pages/SignIn";
import CreateProfile from "./pages/CreateProfile";
import { ThemeProvider } from "./contexts/ThemeContext";
import app from "./firebase";
import { UserProvider } from "./contexts/UserContext";
import { UserProfileProvider } from "./contexts/UserProfileContext";
import { SpeechBubbleProvider } from "./contexts/SpeechBubbleContext";
import NavBar from "./components/NavBar";
import ProtectedRoute from "./components/ProtectedRoute";
import ColoringPages from "./components/ColoringPages";
import AddToHomeScreenGuide from "./components/AddToHomeScreenGuide";
import "./App.css";
import "./styles/modal.css";

console.log("Firebase initialized:", app);

function App() {
  return (
    <UserProvider>
      <UserProfileProvider>
        <ThemeProvider>
          <SpeechBubbleProvider>
            <Router>
              <NavBar />
              <Routes>
                <Route path="/" element={<Navigate to="/games" replace />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/coloring-pages" element={<ColoringPages />} />
                <Route path="/create-profile" element={<CreateProfile />} />

                <Route
                  path="/games/*"
                  element={
                    <ProtectedRoute>
                      <Game />
                    </ProtectedRoute>
                  }
                />
              </Routes>

              <AddToHomeScreenGuide />
            </Router>
          </SpeechBubbleProvider>
        </ThemeProvider>
      </UserProfileProvider>
    </UserProvider>
  );
}

export default App;
